import React from 'react';
import { Chip } from '@mui/material';
import type { IncidentStatus } from '../../types/canvision.types';

interface IncidentStatusBadgeProps {
  status: IncidentStatus;
  size?: 'small' | 'medium';
}

// Status badge colors using MUI theme tokens
const STATUS_COLORS: Record<IncidentStatus, { bg: string; text: string }> = {
  new: { bg: 'primary.main', text: 'common.white' },
  reviewing: { bg: 'warning.main', text: 'common.white' },
  dispatched: { bg: 'secondary.main', text: 'common.white' },
  resolved: { bg: 'success.main', text: 'common.white' },
  closed: { bg: 'grey.600', text: 'common.white' },
  dismissed: { bg: 'grey.400', text: 'common.white' },
};

const STATUS_LABELS: Record<IncidentStatus, string> = {
  new: 'NEW',
  reviewing: 'REVIEWING',
  dispatched: 'DISPATCHED',
  resolved: 'RESOLVED',
  closed: 'CLOSED',
  dismissed: 'DISMISSED',
};

function IncidentStatusBadge({ status, size = 'small' }: IncidentStatusBadgeProps) {
  const colors = STATUS_COLORS[status] || STATUS_COLORS.new;

  return (
    <Chip
      label={STATUS_LABELS[status] || status.toUpperCase()}
      size={size}
      sx={{
        bgcolor: colors.bg,
        color: colors.text,
        fontWeight: 'bold',
        fontSize: size === 'small' ? '0.7rem' : '0.8rem',
      }}
    />
  );
}

export default IncidentStatusBadge;
